export default "__VITE_ASSET__966a797a__"